export default __webpack_public_path__ + "static/media/cute_dog.c05bea8a.png";